import {toTitleCase} from '@util/StringUtils';
import View from '@core/View';

export default {
    orderStatusBadgeView: new View( 'orderStatusBadge' ),

    renderStatusBadge: function ( status ) {
        return this.orderStatusBadgeView.render( this.serializeBadgeData( status ) );
    },

    serializeBadgeData: function ( status ) {
        var data;

        switch ( status.toLowerCase() ) {
            case 'approve':
                data = {
                    badgeClassName: 'hollow',
                    badgeIconClassName: 'ok'
                };
                break;

            // intentional fall through
            case 'reject':
            case 'cancelled':
                data = {
                    badgeClassName: 'notification',
                    badgeIconClassName: 'remove'
                };
                break;

            // intentional fall through
            case 'delivered':
            case 'shipped':
                data = {
                    badgeClassName: 'success',
                    badgeIconClassName: 'ok'
                };
                break;

            default: // 'pending','entered', 'processing'
                data = {
                    badgeClassName: 'hollow',
                    badgeIconClassName: 'time'
                };
        }

        // change verb to adj.
        if ( status == 'approve' ) {
            status += 'd';
        }
        else if ( status == 'reject' ) {
            status += 'ed';
        }

        data.badgeText = toTitleCase( 'order ' + status );

        return data;

    }

};

